<template>
  <v-app id="app">
    <div id="main-container-wrapper">
      <v-container
        id="main-container"
        class="py-12"
      >
        <router-view />
      </v-container>
      <p>
        Táto aplikácia vychádza z  <a
          target="_blank"
          href="https://github.com/dgca-verifier/dgca-verifier-webapp"
          rel="noreferrer"
        >open source</a>
        zdrojov, pôvodní autori sú
        <a
          target="_blank"
          href="https://github.com/cifred98"
          rel="noreferrer"
        >cifred98</a>
        a <a
          target="_blank"
          href="https://github.com/kael-k"
          rel="noreferrer"
        >kael_k</a>
      </p>
      <p>
        Verzia: 20210822-1448
        <br>
        by Slavoj SANTA Hruška
      </p>
    </div>
    <div id="green-box-background" />
  </v-app>
</template>
<script>
export default {
  name: 'App',
  components: {}
}

</script>

<style lang="scss">
@import '~vuetify/src/styles/settings/_variables';
@import "assets/style/index.scss";

#v-app > .v-application--wrap{
  min-height: 100vh;
  background: #fafafa;
  display: block;
  z-index: 0;
  position: relative;
}

#main-container-wrapper{
  display: flex;
  flex-direction: column;
  height: 100%;
  z-index: 1;
}

#main-container-wrapper > p {
  margin-top: auto;
  margin-bottom: 0;
  font-size: 1.2em;
  color: #fafafa;
  text-align: center;
  padding: 1em;
}

#main-container-wrapper > p > a {
  color: #ffffff;
}

#main-container{
  height: inherit;
  padding: 0;
  position: relative;
  max-width: 1000px;
}

#green-box-background{
  position: fixed;
  z-index: 0;
  background: linear-gradient(0deg, rgba(170,126,79,1) 0%, rgba(199,165,125,1) 85%, rgba(146,98,50,1) 100%);
  height: 30vh;
  top: 70vh;
  width: 100vw;
  left: 0;
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  #main-container {
    padding: 1em !important;
    height: 100%;
  }
}

</style>
